import { useState } from 'react'
import { Box, Button, Card, Stack, Typography } from '@mui/material'
import { i18WithParams as t } from '@shared/locale'
import { getAdyenCardDetails } from 'components-ui/src/shared/adyen'
import { useLocationContext } from '@providers/location'
import { DeleteCardModal } from './dialog/delete_card_modal'
import { ExternalStoredPaymentMethodClientDto } from 'service-api/src/types/api'

export const PaymentCard = ({
  paymentMethod,
  onDelete,
}: {
  paymentMethod: ExternalStoredPaymentMethodClientDto
  onDelete: (id: string) => Promise<void>
}) => {
  const [cardToDelete, setCardToDelete] = useState<ExternalStoredPaymentMethodClientDto | null>(null)

  const handleDeleteConfirm = async () => {
    await onDelete(paymentMethod.id!)
    setCardToDelete(null)
  }

  const { location } = useLocationContext()
  const cardDetails = getAdyenCardDetails(paymentMethod, location?.timezone)

  return (
    <>
      <Box key={paymentMethod.id} width={'100%'}>
        <Card sx={{ p: 2 }}>
          <Stack gap={1}>
            <Stack direction="row" justifyContent="space-between">
              <Stack direction="row" alignItems="center" gap={1}>
                <Box sx={{ mt: 0.5 }}>{cardDetails.logo}</Box>
                <Typography variant="body1">
                  {cardDetails.displayName} {cardDetails.lastFourDigits}
                </Typography>
              </Stack>
              <Button variant="text" onClick={() => setCardToDelete(paymentMethod)}>
                {t('profile.paymentMethod.delete.button')}
              </Button>
            </Stack>
            {cardDetails.isExpired ? (
              <Typography variant="body1bold" color="error">
                {t('profile.paymentMethod.expired')} {cardDetails.expiry}
              </Typography>
            ) : (
              <Typography variant="body1">
                {t('profile.paymentMethod.expires')} {cardDetails.expiry}
              </Typography>
            )}
          </Stack>
        </Card>
      </Box>

      {!!cardToDelete && (
        <DeleteCardModal
          card={cardToDelete}
          onClose={async () => setCardToDelete(null)}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </>
  )
}
